/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Equipment\CarEquipment.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Monday March 25th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 25th 2024 5:48:25 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { CarEquipmentType } from "Type/singleCarDbType";
import { useEffect, useState } from "react";
import { EquipmentList } from "./EquipmentList";
import { UpdateCarType } from "Type/CarElement.type.hold";
import translator from "MultiLanguage/TranslationWrapper";
import CollapseDiv from "Content/CollapseDiv/CollapseDiv";
import CarService from "Services/Car/CarService";

type EquipmentProps = {
    carUpdate: UpdateCarType;
    // Equipments: CarEquipmentType[];
    disabled: boolean;
    id: string;
};

export function CarEquipment (props: EquipmentProps) {
    const [equipmentSerial, setEquipmentSerial] = useState<CarEquipmentType[]>();
    const [equipmentOptional, setEquipmentOptional] = useState<CarEquipmentType[]>();

    useEffect(() => {
        CarService.getCarEquipements(props.id!).then((equipments: CarEquipmentType[]) => {
            const tmpEquipmentSerial: CarEquipmentType[] = [];
            const tmpEquipmentOptional: CarEquipmentType[] = [];
            for (let i = 0; i < equipments.length; ++i) {
                if (!equipments[i].Optionnal)
                    tmpEquipmentSerial.push(equipments[i]);
                else
                    tmpEquipmentOptional.push(equipments[i]);
            }
            setEquipmentSerial(tmpEquipmentSerial);
            setEquipmentOptional(tmpEquipmentOptional);
        }).catch((error: any) => {
            console.log(error);
        });
    }, [])

    // useEffect(()=>{
    //     const tmpEquipmentSerial: CarEquipmentType[] = [];
    //     const tmpEquipmentOptional: CarEquipmentType[] = [];
    //     for (let i = 0; i < props.Equipments.length; ++i) {
    //         if (!props.Equipments[i].Optionnal)
    //             tmpEquipmentSerial.push(props.Equipments[i]);
    //         else
    //             tmpEquipmentOptional.push(props.Equipments[i]);
    //     }
    //     setEquipmentSerial(tmpEquipmentSerial);
    //     setEquipmentOptional(tmpEquipmentOptional);
    // }, [props.Equipments]);

    return (
        <CollapseDiv title={translator.decode("car.Equipment")}>
            <>
                <EquipmentList title={"serial"} equipmentList={equipmentSerial} carUpdate={props.carUpdate} disabled={props.disabled} />
                <EquipmentList title={"option"} equipmentList={equipmentOptional} carUpdate={props.carUpdate} disabled={props.disabled} />
            </>
        </CollapseDiv>
    )
};
